import { render } from "./inputNumberRange.vue?vue&type=template&id=06a759c4"
import script from "./inputNumberRange.vue?vue&type=script&lang=js"
export * from "./inputNumberRange.vue?vue&type=script&lang=js"

import exportComponent from "D:\\php\\php20260824_dianshang\\mall-son_dxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__